import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlSizeEnum, IconEnum } from 'datnek-ds';

@Component({
  selector: 'nk-shared-accordion-group',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;

  /**
   * If the panel is opened or closed
   */
  @Input() opened = false;

  /**
   * Text to display in the group title bar
   */
  @Input() title!: string;

  /**
   * Emitted when user clicks on group titlebar
   * @type {EventEmitter<any>}
   */
  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {}
}
